import React from 'react'
import { useState } from 'react';
import FAQ from '../../components/FAQ'
import Workhero from './Workhero';
import Demographic from './Demographic';
import Dataquality from './Dataquality';
import CTA from '../../components/CTA';

const HowWork = () => {
    const [selectFaq, setSelecteFaq] = useState(null);
  const content = [
    {
      id:1,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {
      id:2,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {
      id:3,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:4,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:5,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
  ];
  const handleShowContent = (id) => {
    if (selectFaq) {
      setSelecteFaq(null);
    } else {
      setSelecteFaq(id);
    }
  };
  return (
    <div>
        <Workhero></Workhero>
        <Demographic></Demographic>
        <Dataquality></Dataquality>
        <div className="faq-main">
        <p>Frequently Asked Questions</p>
        <h1>What Do You Need Help With?</h1>
        <div className="faq-box">
          {content.map((val, i) => (
            <FAQ
              key={i}
              showContent={selectFaq === val.id ? true : false}
              handleSelectFaq={() => handleShowContent(val.id)}
              title={val.title}
              answer={val.content}
            ></FAQ>
          ))}
        </div>
      </div>
      <CTA></CTA>
    </div>
  )
}

export default HowWork;